export const catalog_matrix = [
  {form_key:'patient_provider_id', catalog_key:'providers'},
  {form_key:'alternative_hospital_id', catalog_key:'hospitals'},
  //{form_key:'responsible_id', catalog_key:'none', propname:'users'},
]